// Runtime environment. The Flask shell injects window.__ENV__ with the backend
// API origin so a single built bundle works across dev/stage/prod without a
// per-environment rebuild.

declare global {
  interface Window {
    __ENV__?: { API_BASE_URL?: string };
  }
}

export function apiBaseUrl(): string {
  const fromWindow = typeof window !== 'undefined' ? window.__ENV__?.API_BASE_URL : undefined;
  return (fromWindow || 'http://localhost:8081').replace(/\/$/, '');
}

export {};
